// Phone-number parsing/normalization for Moroccan mobile numbers, plus
// Arabic-Indic digit conversion. Pure functions, no DOM/app state. Extracted
// verbatim from public/index.html's inline script (Phase 2 modularization).
export function convertDigits(s) {
  return (s || '').replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
}

export function normalizePhone(raw) {
  if (!raw) return { value: '', valid: false };
  let s = convertDigits(String(raw)).replace(/[^\d+]/g, '');
  s = s.replace(/^00212/, '0').replace(/^\+212/, '0').replace(/^212/, '0');
  if (/^[567]\d{8}$/.test(s)) s = '0' + s;
  return { value: s, valid: /^0[567]\d{8}$/.test(s) };
}

export function findPhones(text) {
  text = convertDigits(text);
  const out = [], seen = new Set();
  const re = /(?:(?:\+|00)?212|0)?[\s.\-\/]?[567](?:[\s.\-\/]?\d){8}/g;
  let m;
  while ((m = re.exec(text)) !== null) {
    const p = normalizePhone(m[0]);
    if (p.valid && !seen.has(p.value)) { seen.add(p.value); out.push({ value: p.value, index: m.index, raw: m[0] }); }
  }
  return out;
}
